import { useCallback } from 'react';
import useAPI, { type State } from '~/common/hooks/useAPI';
import getIntegrationLabels from '~/common/utils/integrations-client/jira/getIntegrationLabels';

export interface IntegrationLabelsState extends Omit<State<string[]>, 'data'> {
  labels: string[] | null;
}

const useIntegrationLabels = (
  enterpriseId: string,
  connectionId: string,
  projectId: string,
  token?: string
): IntegrationLabelsState => {
  const dataLoader = useCallback(() => {
    if (!connectionId || !enterpriseId || !projectId) {
      return Promise.resolve([]);
    }

    return getIntegrationLabels({
      enterpriseId,
      connectionId,
      projectId,
      token
    });
  }, [enterpriseId, connectionId, projectId, token]);

  const state = useAPI(dataLoader);

  return { loading: state.loading, error: state.error, labels: state.data };
};

export default useIntegrationLabels;
